import type { BatchLiabilityResultItem } from '@/features/cbam-reporting/hooks/cbamLiability'
import { CbamSimulationGood } from '@/features/cbam-simulations-v2/hooks/cbamSimulationGoods'
import CbamSimulationGoodRow from './CbamSimulationGoodRow'
import { Table, TableColumnHeader, TableRow } from '@/common'
import useI18n from '@/shared/hooks/usei18n'
import { useNetMassDisplay } from '@/shared/netMassDisplay/NetMassDisplayUnitContext'

type CbamSimulationGoodsTableProps = {
  cbamSimulationGoods: CbamSimulationGood[]
  onInspectGood: (good: CbamSimulationGood) => void
  liabilityByGoodId: Map<string, BatchLiabilityResultItem>
  projectionYear: string
  onEditGood: (good: CbamSimulationGood) => void
  onDeleteGood: (good: CbamSimulationGood) => void
}

export default function CbamSimulationGoodsTable({
  cbamSimulationGoods,
  onInspectGood,
  liabilityByGoodId,
  projectionYear,
  onEditGood,
  onDeleteGood
}: CbamSimulationGoodsTableProps) {
  const { t } = useI18n()
  const { netMassColumnLabel } = useNetMassDisplay()

  return (
    <div className="overflow-x-auto w-full">
      <Table className="table-fixed">
        <thead>
          <TableRow>
            <TableColumnHeader className="w-26">
              {t(
                'cbamSimulations:cbamSimulationDetails.simulationGoodsTable.headers.importDateAndQuarter'
              )}
            </TableColumnHeader>
            <TableColumnHeader className="w-26">
              {t('cbamSimulations:cbamSimulationDetails.simulationGoodsTable.headers.nameOfGood')}
            </TableColumnHeader>
            <TableColumnHeader className="w-26">
              {t(
                'cbamSimulations:cbamSimulationDetails.simulationGoodsTable.headers.countryOfOrigin'
              )}
            </TableColumnHeader>
            <TableColumnHeader className="w-26">
              {t('cbamSimulations:cbamSimulationDetails.simulationGoodsTable.headers.cnCode')}
            </TableColumnHeader>
            <TableColumnHeader className="w-16" align="right">
              {netMassColumnLabel}
            </TableColumnHeader>
            <TableColumnHeader className="w-40" align="right">
              {t(
                'cbamSimulations:cbamSimulationDetails.simulationGoodsTable.headers.certificatesPerTonneBaseCase'
              )}
            </TableColumnHeader>
            <TableColumnHeader className="w-40" align="right">
              {t(
                'cbamSimulations:cbamSimulationDetails.simulationGoodsTable.headers.totalCertificatesRequiredBaseCase'
              )}
            </TableColumnHeader>
            <TableColumnHeader className="w-26" />
          </TableRow>
        </thead>
        <tbody>
          {cbamSimulationGoods.map(cbamSimulationGood => (
            <CbamSimulationGoodRow
              key={cbamSimulationGood.id}
              cbamSimulationGood={cbamSimulationGood}
              onInspect={onInspectGood}
              liabilityResult={liabilityByGoodId.get(cbamSimulationGood.id) ?? null}
              projectionYear={projectionYear}
              onEdit={onEditGood}
              onDelete={onDeleteGood}
            />
          ))}
        </tbody>
      </Table>
    </div>
  )
}
